module.exports = __webpack_public_path__ + "static/media/circle icon-1_new.64f77716.png";